var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopylink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.485,
    height: 20.485,
    viewBox: "0 0 20.485 20.485",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "COPY_LINK",
    "data-name": "COPY LINK",
    d: "M12.708,18.364l-1.414,1.414a5,5,0,0,1-7.071-7.071l1.414-1.414m12.728,1.414,1.414-1.414a5,5,0,0,0-7.071-7.071L11.293,5.636M8.5,15.5l7-7",
    transform: "translate(-1.758 -1.757)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopylink);
export default __webpack_public_path__ + "static/media/copylink.edf160793124fdf608bcef6843e3fa72.svg";
export { ForwardRef as ReactComponent };